export default __webpack_public_path__ + "static/Economic Model Update - Russian-3a7a96462cb935752d338459d6a84c05.pdf";